import { useState } from "react";

const navItems = [
  { label: "今日热议", href: "#talk" },
  { label: "人物深扒", href: "#people" },
  { label: "瓜田速报", href: "#feed" },
  { label: "塌房时间线", href: "#timeline" },
  { label: "黑料合集", href: "#archive" },
  { label: "热度榜", href: "#rank" },
];

const dateText = new Date().toLocaleDateString("zh-CN", {
  year: "numeric",
  month: "long",
  day: "numeric",
  weekday: "long",
});

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-foreground-200/60 bg-background-50/90 backdrop-blur-md">
      {/* 顶部细信息条 */}
      <div className="hidden border-b border-foreground-200/50 bg-background-100/80 md:block">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-4 py-1.5 text-xs text-foreground-600">
          <p className="whitespace-nowrap">
            <i className="ri-calendar-line mr-1" />
            {dateText} · 爆料资讯持续更新
          </p>
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1 whitespace-nowrap">
              <i className="ri-flashlight-fill text-accent-500" />
              今日新增深扒 18 篇
            </span>
            <a href="#rank" className="whitespace-nowrap text-foreground-500 transition-colors hover:text-primary-600">
              实时热度榜 <i className="ri-arrow-right-up-line ml-0.5" />
            </a>
          </div>
        </div>
      </div>

      {/* 品牌主行 */}
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3">
        <a href="#top" className="group flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
            <i className="ri-eye-2-line text-2xl" />
          </span>
          <span className="leading-none">
            <span className="font-heading block text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              网曝网
            </span>
            <span className="mt-1 hidden text-[11px] font-medium tracking-[0.28em] text-foreground-500 sm:block">
              WANGBAO · 深度吃瓜档案
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-2 lg:flex">
          <div className="flex h-10 w-80 items-center gap-2 rounded-md border border-foreground-300/60 bg-background-100/70 px-3">
            <i className="ri-search-line text-foreground-500" />
            <input
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              placeholder="搜人物 / 事件 / 平台账号"
              aria-label="搜索"
            />
            <span className="whitespace-nowrap rounded bg-secondary-200 px-1.5 py-0.5 text-[11px] text-secondary-900">搜索</span>
          </div>
          <a
            href="#download"
            className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-foreground-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line" />
            下载 App
          </a>
          <a
            href="#subscribe"
            className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300/60 px-4 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600"
          >
            订阅提醒
          </a>
        </div>

        {/* 移动端按钮 */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-foreground-300/60 text-foreground-800 md:hidden"
          aria-label="菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {/* 栏目导航 */}
      <div className="hidden border-t border-foreground-200/50 md:block">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-4">
          <nav className="flex items-center gap-1">
            <a href="#top" className="inline-flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-600">
              <i className="ri-fire-fill text-primary-500" />
              头条
            </a>
            {navItems.map((n) => (
              <a key={n.href} href={n.href} className="whitespace-nowrap px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600">
                {n.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <a href="#" className="flex items-center gap-1 transition-colors hover:text-primary-600"><i className="ri-weibo-line text-base" />微博</a>
            <a href="#" className="flex items-center gap-1 transition-colors hover:text-primary-600"><i className="ri-wechat-line text-base" />公众号</a>
            <a href="#" className="flex items-center gap-1 transition-colors hover:text-primary-600"><i className="ri-douban-line text-base" />豆瓣</a>
          </div>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-foreground-200/50 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex h-10 items-center gap-2 rounded-md border border-foreground-300/60 bg-background-100/70 px-3">
            <i className="ri-search-line text-foreground-500" />
            <input className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400" placeholder="搜人物 / 事件 / 平台账号" />
          </div>
          <nav className="mt-3 grid grid-cols-2 gap-1">
            <a href="#top" className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100">头条</a>
            {navItems.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100">
                {n.label}
              </a>
            ))}
          </nav>
          <a href="#download" className="mt-3 flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-foreground-50">
            <i className="ri-download-2-line" />下载 App
          </a>
        </div>
      )}
    </header>
  );
}